import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

/**
 * P1 #53 — Update-Banner. Sichtbar für admin/developer, wenn das Release-Manifest
 * eine neuere Version als die installierte meldet. Zeigt den kundentauglichen
 * Changelog auf Klick. (Installation erfolgt separat — bei einem Kunden derzeit
 * dezentral/manuell durch admin.)
 */
export function UpdateBanner() {
  const [info, setInfo] = useState<Awaited<ReturnType<typeof api.system.updateStatus>> | null>(null);
  const [show, setShow] = useState(true);
  const [details, setDetails] = useState(false);

  // Periodisch prüfen, damit das Banner nach einem Install automatisch
  // verschwindet (ohne manuelles Refresh), sobald kein Update mehr ansteht.
  useEffect(() => {
    let alive = true;
    const load = () => api.system.updateStatus().then((d) => { if (alive) setInfo(d); }).catch(() => {});
    load();
    const t = window.setInterval(load, 15000);
    return () => { alive = false; window.clearInterval(t); };
  }, []);

  // Im Live-/Entwicklermodus ist die Version "dev" (kein gebackenes APP_VERSION) —
  // ein "Update verfügbar"-Banner wäre dort sinnlos (man arbeitet direkt am Code).
  if (!info || !info.updateAvailable || !show || info.current === "dev") return null;

  return (
    <div
      className="update-banner"
      style={{
        background: "#eff6ff", borderBottom: "1px solid #bfdbfe", padding: "8px 16px",
        fontSize: 14, display: "flex", gap: 12, alignItems: "baseline", flexWrap: "wrap",
      }}
    >
      <strong style={{ color: "#1a6ee8" }}>🔔 Update verfügbar: {info.latest}</strong>
      <span className="muted">(installiert: {info.current})</span>
      <button type="button" className="link" onClick={() => setDetails((d) => !d)}>
        {details ? "Changelog ausblenden" : "Was ist neu?"}
      </button>
      <Link to="/settings/updates" style={{ fontWeight: 600, color: "#1a6ee8", textDecoration: "underline" }}>
        Update installieren →
      </Link>
      <button type="button" className="link" style={{ marginLeft: "auto" }} onClick={() => setShow(false)}>
        ausblenden
      </button>
      {details && info.latestChangelog && (
        <div style={{ flexBasis: "100%", marginTop: 6, whiteSpace: "pre-wrap", color: "#1a2233" }}>
          {info.latestChangelog}
        </div>
      )}
    </div>
  );
}
